/** Function that takes in a string, and returns the string with first character capitalized. */

export const capitalizeFirstCharacter = (string = "") =>
  string.charAt(0).toUpperCase() + string.slice(1);
